import { ApiResult } from 'interfaces/APITypes';
import { ContentSet, NamedCropDimensions, StudioFile } from 'interfaces/StudioTypes';

import { contentInstance, makeRequest } from './client';

export const uploadImage = async (file: File): Promise<ApiResult> => {
  const formData = new FormData();
  formData.append('image', file, file.name);

  return makeRequest(contentInstance.post('/upload-image', formData));
};

export const updateImage = async ({
  pack,
  uuid: id,
  crop,
}: {
  pack: string;
  uuid: string;
  crop: NamedCropDimensions;
}): Promise<ApiResult> => {
  return makeRequest(contentInstance.patch(`/content-sets/${pack}/images/${id}`, { crop }));
};

export const removeImageFromSet = async (set: ContentSet, file: StudioFile): Promise<ApiResult> => {
  return makeRequest(contentInstance.delete(`/content-sets/${set.id}/images/${file.id}`));
};
